<h2 mat-dialog-title class="text-center">
    <span class="text-white">{{ isEditMode ? 'Editar Entidad' : 'Crear Nueva Entidad' }}</span>
    <button matIconButton (click)="onCancel()" class="dialog-close top-0 right-0">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content>
    <form [formGroup]="entityForm" (ngSubmit)="onSubmit()">
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Nombre de la Entidad</mat-label>
            <input matInput formControlName="name" placeholder="Ej: Nueva Unibus" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="nameControl?.invalid && (nameControl?.dirty || nameControl?.touched)">
                <span *ngIf="nameControl?.errors?.['required']">El nombre de la entidad es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Correo de la Entidad</mat-label>
            <input matInput formControlName="entityEmail" placeholder="Ej: juan.perez@example.com" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="entityEmailControl?.invalid && (entityEmailControl?.dirty || entityEmailControl?.touched)">
                <span *ngIf="entityEmailControl?.errors?.['required']">El correo de la entidad es requerido.</span>
                <span *ngIf="entityEmailControl?.errors?.['email']">Ingrese un formato de correo válido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Representante Legal</mat-label>
            <input matInput formControlName="legalRepresentative" placeholder="Ej: Juan Pérez" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="legalRepresentativeControl?.invalid && (legalRepresentativeControl?.dirty || legalRepresentativeControl?.touched)">
                <span *ngIf="legalRepresentativeControl?.errors?.['required']">El nombre del representante legal es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Correo del Representante Legal</mat-label>
            <input matInput formControlName="legalRepresentativeEmail" placeholder="Ej: juan.perez@example.com" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="legalRepresentativeEmailControl?.invalid && (legalRepresentativeEmailControl?.dirty || legalRepresentativeEmailControl?.touched)">
                <span *ngIf="legalRepresentativeEmailControl?.errors?.['required']">El correo del representante legal es requerido.</span>
                <span *ngIf="legalRepresentativeEmailControl?.errors?.['email']">Ingrese un formato de correo válido.</span>
            </mat-error>
        </mat-form-field>
        <mat-slide-toggle formControlName="status" class="mb-4">Activo</mat-slide-toggle>
        <div>
            <button matButton type="submit" class="w-full">Guardar</button>
        </div>
    </form>
</mat-dialog-content>